import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { PlusIcon, MinusIcon } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Voy a romper el vínculo con mi bebé?',
    a: 'No. Un bebé descansado es un bebé más feliz y conectado durante las horas de juego.'
  }, {
    q: '¿Tengo que dejarlo llorar por horas?',
    a: 'No. El método usa intervenciones de conexión cada ciertos minutos para que el bebé nunca se sienta abandonado.'
  }, {
    q: '¿Sirve si hacemos colecho?',
    a: 'Sí, el manual incluye adaptaciones para habitación compartida.'
  }];
  return <section className="py-24 px-4 bg-cream-100 text-navy-900" data-id="element-38">
      <div className="max-w-3xl mx-auto" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-40">
          <h2 className="text-3xl md:text-4xl font-display font-bold text-navy-950 mb-4" data-id="element-41">
            Preguntas Frecuentes
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-42">
          {faqs.map((faq, index) => <FAQItem key={index} question={faq.q} answer={faq.a} index={index} data-id="element-43" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  question,
  answer,
  index
}: {
  question: string;
  answer: string;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  return <motion.div initial={{
    opacity: 0,
    y: 10
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.4,
    delay: index * 0.1
  }} className="bg-white rounded-2xl shadow-sm border border-cream-200 overflow-hidden" data-id="element-44">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-45">
        <span className="text-lg font-display font-bold text-navy-900 pr-4" data-id="element-46">
          {question}
        </span>
        <div className="flex-shrink-0 text-amber-500" data-id="element-47">
          {isOpen ? <MinusIcon className="w-5 h-5" data-id="element-48" /> : <PlusIcon className="w-5 h-5" data-id="element-49" />}
        </div>
      </button>

      <AnimatePresence data-id="element-50">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-51">
            <div className="px-6 pb-5 text-navy-700 font-body leading-relaxed border-t border-cream-100 pt-4" data-id="element-52">
              {answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}